export default __webpack_public_path__ + "static/media/14-1.954c77d0.jpg";